import { pipelineConstants } from '../_constants';

export function pipeline(state = {}, action) {
//	console.log('pipeline reducer was called with state', state, 'and action', action)
    switch (action.type) {
        case pipelineConstants.GET_PIPELINE_SUCCESS:
            return {
							launchId: action.launchID,
							isLoading: false
						};
        case pipelineConstants.GET_PIPELINE_REQUEST:
            return {isLoading: true};
        case pipelineConstants.GET_PIPELINE_FAILURE:
            return {
							hasErrored: action.hasErrored,
							isLoading: false
						};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/pipeline.js